module.exports = __webpack_public_path__ + "static/media/contact1.f1caa533.jpg";